window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

// Dados em memória (Populado via Supabase)
window.FazendaRP.SuprimentosData = [];

// Cache de carregamento para evitar flicker excessivo
window.FazendaRP.SuprimentosLoaded = false;

// Standard Unit Options
const UNIDADE_OPTS = [
    { val: 'UN', label: 'Unidade (UN)' },
    { val: 'PC', label: 'Peça (PC)' },
    { val: 'DS', label: 'Dose (DS)' },
    { val: 'L', label: 'Litro (L)' },
    { val: 'KG', label: 'Quilo (KG)' },
    { val: 'PCT', label: 'Pacote (PCT)' },
    { val: 'CX', label: 'Caixa (CX)' },
    { val: 'SC', label: 'Saca (SC)' },
    { val: 'BAG', label: 'Bag (BAG)' },
    { val: 'BD', label: 'Balde (BD)' },
    { val: 'TON', label: 'Tonelada (TON)' },
    { val: 'M', label: 'Metro (M)' },
    { val: 'M2', label: 'Metro Quadrado (M²)' },
    { val: 'M3', label: 'Metro Cúbico (M³)' },
    { val: 'JG', label: 'Jogo (JG)' }
];

window.FazendaRP.Pages.suprimentos = {
    tempContas: [],
    tempUnidades: [], // For modal unit management

    render: function (container) {
        container.innerHTML = `
            <div id="suprimentos-module">
                <div class="submenu-header">
                    <div class="submenu-container" style="flex-wrap: wrap;">
                        <div class="submenu-item active" data-tab="dashboard"><i class="fas fa-chart-pie"></i> Visão Geral</div>
                        <div class="submenu-item" data-tab="catalogo"><i class="fas fa-book-open"></i> Catálogo de Materiais</div>
                        <div class="submenu-item" data-tab="historico"><i class="fas fa-chart-line"></i> Histórico de Compras</div>
                        <div class="submenu-item" data-tab="estoque"><i class="fas fa-cubes"></i> Controle de Estoque</div>
                        <div class="submenu-item" data-tab="compras"><i class="fas fa-shopping-cart"></i> Pedidos de Compra</div>
                    </div>
                </div>

                <div id="suprimentos-content" style="padding: 20px;"></div>

                <!-- MODAL NOVA CATEGORIA -->
                <div id="modal-nova-categoria" class="modal-overlay" style="display: none;">
                    <div class="modal-content" style="width: 450px;">
                        <h3>Nova Categoria</h3>
                        <form id="form-nova-categoria">
                            <div class="form-group">
                                <label>Nome da Categoria</label>
                                <input type="text" id="cat-nome-modal" class="form-control" required placeholder="Ex: Combustíveis">
                            </div>
                            <div class="form-group" style="margin-top:10px;">
                                <label style="display:flex; justify-content: space-between; align-items:center; cursor:pointer; font-weight:normal; font-size:0.9rem; width:100%;">
                                     <span>Exigir vínculo com Máquina (Frota)</span>
                                     <input type="checkbox" id="cat-fluxo-maquina-modal">
                                </label>
                                <small style="color:#666; display:block; margin-left:22px; margin-top:2px; font-size:0.8rem;">DICA: Recomendado marcar apenas em <strong>Subcategorias</strong> específicas.</small>
                            </div>
                            <div class="form-group">
                                <label>Localização (Onde criar?)</label>
                                <select id="cat-parent-select" class="form-control">
                                    <option value="ROOT">📂 Nova Categoria Raiz</option>
                                </select>
                            </div>
                            <div class="modal-actions">
                                <button type="button" class="btn-cancel" onclick="document.getElementById('modal-nova-categoria').style.display='none'">Cancelar</button>
                                <button type="submit" class="btn-confirm">Criar</button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- MODAL NOVO MATERIAL -->
                <div id="modal-novo-material" class="modal-overlay" style="display: none;">
                    <div class="modal-content" style="width: 500px;">
                        <h3>Novo Material</h3>
                        <form id="form-novo-material">
                            <div class="form-group">
                                <label>Nome do Material</label>
                                <input type="text" id="mat-nome-modal" class="form-control" required placeholder="Ex: Diesel S10">
                            </div>
                            <div style="margin-bottom: 10px; background: #f9f9f9; padding: 10px 12px; border-radius: 4px; border: 1px solid #eee; text-align: left;">
                                 <label style="display:flex; align-items:center; justify-content: flex-start; cursor:pointer; margin:0; width: 100%;">
                                      <input type="checkbox" id="mat-is-variation" style="margin-right: 12px; accent-color: #059669; transform: scale(1.1); cursor: pointer; width: auto !important; margin-top: 0;">
                                      <span style="font-weight: 600; font-size: 0.95rem; color: #374151;">Este item é uma variação (Marca/Tipo)?</span>
                                 </label>
                            </div>

                            <div class="form-group" id="div-mat-category">
                                <label>Categoria Pai</label>
                                <select id="mat-parent-select" class="form-control">
                                    <option value="" disabled selected>Selecione uma categoria...</option>
                                </select>
                            </div>

                            <div class="form-group" id="div-mat-parent-item" style="display: none;">
                                <label>Item Pai (Genérico)</label>
                                <input class="form-control" list="list-parent-items" id="mat-parent-search" placeholder="Selecione ou busque o item pai..." autocomplete="off">
                                <datalist id="list-parent-items"></datalist>
                            </div>
                            
                            <!-- Multi-Unit Selection -->
                            <div class="form-group">
                                <label>Unidades de Medida</label>
                                <div id="modal-units-chips" style="display:flex; flex-wrap:wrap; gap:5px; margin-bottom:5px;"></div>
                                <div style="display:flex; gap:5px;">
                                    <select id="mat-unidade-select" class="form-control">
                                        ${UNIDADE_OPTS.map(u => `<option value="${u.val}">${u.label}</option>`).join('')}
                                    </select>
                                    <button type="button" id="btn-add-unit-modal" class="btn-add-plus">+</button>
                                </div>
                                <small style="color:#666;">Você pode adicionar múltiplas unidades (ex: Litro e Galão).</small>
                            </div>

                            <div style="border-top:1px solid #eee; padding-top:10px; margin-top:15px;">
                                <label>Vínculos Contábeis (Opcional)</label>
                                <div id="modal-chips-container" style="display:flex; flex-wrap:wrap; gap:5px; margin-bottom:10px; min-height:30px;"></div>
                                <div style="display:flex; gap:5px;">
                                    <input list="list-plano-contas-modal" id="input-conta-modal" class="form-control" placeholder="Adicionar conta...">
                                    <datalist id="list-plano-contas-modal"></datalist>
                                    <button type="button" id="btn-add-conta-modal" class="btn-add-plus">+</button>
                                </div>
                            </div>

                            <div class="modal-actions" style="margin-top:20px;">
                                <button type="button" class="btn-cancel" onclick="document.getElementById('modal-novo-material').style.display='none'">Cancelar</button>
                                <button type="submit" class="btn-confirm">Criar Material</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
             <style>
                .modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 2000; display: flex; align-items: center; justify-content: center; }
                .modal-content { background: white; padding: 25px; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.2); }
                .modal-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px; }
                
                .btn-cancel { background: none; border: 1px solid #ccc; padding: 6px 14px; border-radius: 4px; cursor: pointer; }
                .btn-confirm { background: #059669; color: white; border: none; padding: 6px 14px; border-radius: 4px; cursor: pointer; }
                
                /* Large Plus Button Style */
                .btn-add-plus {
                    background: #e5e7eb; 
                    border: 1px solid #d1d5db; 
                    font-size: 1.2rem; 
                    width: 42px; 
                    cursor: pointer; 
                    border-radius: 4px;
                    display: flex; 
                    align-items: center; 
                    justify-content: center;
                    color: #374151;
                    transition: background 0.2s;
                }
                .btn-add-plus:hover { background: #d1d5db; }

                /* Tree Styles */
                .tree-node { padding: 6px 8px; border-radius: 4px; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: background 0.1s; border: 1px solid transparent; }
                .tree-node:hover { background: #f3f4f6; }
                .tree-node.active { background: #ecfdf5; border-color: #d1fae5; color: #065f46; font-weight: 500; }
                
                /* Increased Indentation for Subcategories/Hierarchy - Even deeper for User Request */
                .tree-ul { list-style: none; padding-left: 44px; margin: 0; position: relative; } 
                .tree-ul:before { content: ''; position: absolute; top: 0; bottom: 0; left: 16px; width: 1px; background: #e5e7eb; }
                .tree-li { position: relative; margin-top: 2px; }
                .tree-li:before { content: ''; position: absolute; top: 12px; left: -28px; width: 28px; height: 1px; background: #e5e7eb; }
                .tree-root:before { display: none; }
                
                .chip { display: inline-flex; align-items: center; background: #f0fdf4; border: 1px solid #bbf7d0; padding: 4px 10px; border-radius: 16px; font-size: 0.85rem; color: #166534; margin: 0 5px 5px 0; }
                .chip i { margin-left: 6px; cursor: pointer; opacity: 0.6; }
                .chip i:hover { opacity: 1; color: #dc2626; }
                
                .chip-unit { background: #eff6ff; border-color: #bfdbfe; color: #1e40af; }
            </style>
        `;

        this.setupTabs(container);
        this.bindGlobalEvents();

        // Default Load: Dashboard
        if (window.FazendaRP.Pages.suprimentos.dashboard) {
            const content = document.getElementById('suprimentos-content');
            content.innerHTML = window.FazendaRP.Pages.suprimentos.dashboard.render();
            window.FazendaRP.Pages.suprimentos.dashboard.init();
        } else {
            this.renderCatalogo(); // Fallback
        }
    },

    setupTabs: function (container) {
        const tabs = container.querySelectorAll('.submenu-item');
        const content = container.querySelector('#suprimentos-content');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');

                const target = tab.dataset.tab;
                if (target === 'dashboard') {
                    if (window.FazendaRP.Pages.suprimentos.dashboard) {
                        content.innerHTML = window.FazendaRP.Pages.suprimentos.dashboard.render();
                        window.FazendaRP.Pages.suprimentos.dashboard.init();
                    } else { content.innerHTML = '<p>Erro: Módulo Dashboard não carregado.</p>'; }
                } else if (target === 'catalogo') {
                    this.renderCatalogo();
                } else if (target === 'historico') {
                    content.innerHTML = window.FazendaRP.Pages.suprimentos.historico.render();
                    window.FazendaRP.Pages.suprimentos.historico.init(content);
                } else if (target === 'estoque') {
                    // New Module Link
                    if (window.FazendaRP.Pages.suprimentos.estoque) {
                        window.FazendaRP.Pages.suprimentos.estoque.render(content);
                    } else {
                        content.innerHTML = '<p>Erro: Módulo de Estoque não carregado.</p>';
                    }
                } else {
                    content.innerHTML = `
                         <div class="card" style="text-align: center; padding: 40px; color: var(--text-muted);">
                            <i class="fas fa-hard-hat fa-2x" style="margin-bottom: 15px;"></i>
                            <h3>Em desenvolvimento</h3>
                            <p>Módulo de ${tab.innerText} em breve.</p>
                        </div>
                    `;
                }
            });
        });
    },

    renderCatalogo: function () {
        const container = document.getElementById('suprimentos-content');
        if (!container) return;

        container.innerHTML = `
             <div style="display: flex; height: calc(100vh - 220px); gap: 20px;">
                <!-- Left: Tree View -->
                <div class="card" style="width: 350px; padding: 0; display: flex; flex-direction: column; border-right: 1px solid #e5e7eb;">
                    <div style="padding: 15px; border-bottom: 1px solid #eee; background: #f9fafb; border-radius: 8px 8px 0 0; display: flex; justify-content: space-between; align-items: center; gap: 10px;">
                        <h3 style="margin:0; font-size: 0.95rem; font-weight: 600; color: #374151;">Categorias</h3>
                        <div style="display: flex; gap: 5px;">
                            <button id="btn-add-categ-header" class="btn-sm" style="font-size: 0.8rem; background: #059669; color: white; border: none; border-radius: 4px; padding: 5px 10px; cursor: pointer;">+ Categoria</button>
                            <button id="btn-add-item-header" class="btn-sm" style="font-size: 0.8rem; background: #059669; color: white; border: none; border-radius: 4px; padding: 5px 10px; cursor: pointer;">+ Material</button>
                        </div>
                    </div>
                    
                    <div style="padding: 10px; background: #fff; border-bottom: 1px solid #eee;">
                        <input type="text" id="tree-search-input" placeholder="Buscar material..." style="width: 100%; padding: 6px; border: 1px solid #ddd; border-radius: 4px; font-size: 0.85rem;">
                    </div>
                    <div id="tree-container" style="flex: 1; overflow-y: auto; padding: 10px;"></div>
                </div>

                <!-- Right: Editor -->
                <div class="card" style="flex: 1; padding: 0; display: flex; flex-direction: column; overflow: hidden;">
                     <div id="item-details-container" style="padding: 25px; overflow-y: auto; height: 100%;">
                        <div style="display: flex; flex-direction: column; height: 100%; justify-content: center; align-items: center; color: #9ca3af;">
                            <i class="fas fa-boxes-stacked fa-3x" style="margin-bottom: 15px; opacity: 0.3;"></i>
                            <p>Selecione uma categoria ou item para editar</p>
                        </div>
                    </div>
                </div>
            </div>
        `;

        this.renderTree();
        this.setupGeneralEvents();

        // Initial Data Load
        if (!window.FazendaRP.SuprimentosLoaded) {
            this.loadData();
        }

        const searchInput = document.getElementById('tree-search-input');
        if (searchInput) {
            searchInput.addEventListener('input', (e) => {
                this.renderTree(e.target.value);
            });
        }
    },

    // Carrega dados do Supabase (Filtrando Inativos)
    loadData: async function () {
        const container = document.getElementById('tree-container');
        if (container) container.innerHTML = '<div style="padding:20px; text-align:center; color:#6b7280;"><i class="fas fa-spinner fa-spin"></i> Carregando catálogo...</div>';

        const { data, error } = await window.FazendaRP.supabase
            .from('suprimentos_itens')
            .select('*')
            .neq('status', 'Inativo');

        if (error) {
            console.error('Erro ao carregar suprimetos:', error);
            if (container) container.innerHTML = '<div style="color:red; padding:20px; text-align:center;">Erro ao carregar dados: ' + error.message + ' <br><small>Verifique se a coluna "status" existe na tabela suprimentos_itens.</small></div>';
            return;
        }

        // Mapear snake_case (DB) para camelCase (App)
        window.FazendaRP.SuprimentosData = data.map(item => ({
            id: item.id,
            nome: item.nome,
            tipo: item.tipo,
            parentId: item.parent_id, // DB: parent_id
            expanded: false, // Reset expanded on reload
            unidades: item.unidades || [],
            contas: item.contas || [],
            contas: item.contas || [],
            requiresMachine: item.requires_machine,
            principioAtivo: item.principio_ativo || '' // Map DB field
        }));

        window.FazendaRP.SuprimentosLoaded = true;
        this.renderTree();
    },

    // saveData (LocalStorage) REMOVIDO EM FAVOR DO SUPABASE DIRETO

    renderTree: function (searchTerm = '', customContainer = null, customEditorContainer = null) {
        const container = customContainer || document.getElementById('tree-container');
        if (!container) return;

        const data = window.FazendaRP.SuprimentosData;
        let visibleIds = null;
        if (searchTerm.trim()) {
            visibleIds = new Set();
            const term = searchTerm.toLowerCase();
            // Expanded search to include Active Principle
            const matches = data.filter(d =>
                d.nome.toLowerCase().includes(term) ||
                (d.principioAtivo && d.principioAtivo.toLowerCase().includes(term))
            );
            matches.forEach(m => {
                visibleIds.add(m.id);
                let pid = m.parentId;
                while (pid) {
                    visibleIds.add(pid);
                    const p = data.find(d => d.id === pid);
                    pid = p ? p.parentId : null;
                }
            });
        }

        const buildLevel = (parentId) => {
            let children = data.filter(d => d.parentId === parentId);
            if (children.length === 0) return '';

            children.sort((a, b) => {
                if (a.tipo !== b.tipo) return a.tipo === 'CATEGORIA' ? -1 : 1;
                return a.nome.localeCompare(b.nome);
            });

            let listClass = parentId === null ? 'tree-ul tree-root' : 'tree-ul';
            let html = `<ul class="${listClass}" style="${parentId === null ? 'padding-left: 0;' : ''}">`;
            let hasVisibleChild = false;

            children.forEach(item => {
                if (visibleIds && !visibleIds.has(item.id)) return;
                hasVisibleChild = true;

                const hasChildren = data.some(d => d.parentId === item.id);
                const isItem = item.tipo === 'ITEM';
                const isExpanded = visibleIds ? true : item.expanded;

                // Allow chevron if it is a Category OR if it is an Item with children
                const showChevron = !isItem || hasChildren;

                const icon = isItem ? (hasChildren ? 'fa-boxes-stacked' : 'fa-box') : (isExpanded ? 'fa-folder-open' : 'fa-folder');
                const color = isItem ? '#059669' : '#d97706';

                html += `
                    <li class="tree-li" style="${parentId === null ? 'margin-left: 0;' : ''}">
                        <div class="tree-node" data-id="${item.id}">
                            ${showChevron ? `<i class="fas fa-chevron-${isExpanded ? 'down' : 'right'} toggle-expand" style="font-size: 0.7rem; color: #9ca3af; width: 12px;"></i>` : '<span style="width: 12px"></span>'}
                            <i class="fas ${icon}" style="color: ${color}; font-size: 0.9rem;"></i>
                            <span>${item.nome}</span>
                        </div>
                        ${(showChevron && isExpanded) ? buildLevel(item.id) : ''}
                    </li>
                `;
            });
            html += '</ul>';
            return hasVisibleChild ? html : '';
        };

        const treeContent = buildLevel(null);
        container.innerHTML = treeContent || (searchTerm ? '<div style="color:#999; text-align:center; padding:20px;">Nenhum item encontrado.</div>' : '');

        container.onclick = (e) => {
            if (e.target === container) {
                container.querySelectorAll('.active').forEach(n => n.classList.remove('active'));
                const editorCont = customEditorContainer || document.getElementById('item-details-container');
                if (editorCont) {
                    editorCont.innerHTML = `
                        <div style="display: flex; flex-direction: column; height: 100%; justify-content: center; align-items: center; color: #9ca3af;">
                            <i class="fas fa-boxes-stacked fa-3x" style="margin-bottom: 15px; opacity: 0.3;"></i>
                            <p>Selecione uma categoria ou item</p>
                        </div>
                    `;
                }
            }
        };

        container.querySelectorAll('.tree-node').forEach(node => {
            node.addEventListener('click', (e) => {
                if (e.target.classList.contains('toggle-expand')) return;
                container.querySelectorAll('.tree-node').forEach(n => n.classList.remove('active'));
                node.classList.add('active');
                this.renderEditor(node.dataset.id, customEditorContainer);
                e.stopPropagation();
            });

            const toggle = node.querySelector('.toggle-expand');
            if (toggle) {
                toggle.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (searchTerm) return;
                    const id = node.dataset.id;
                    const item = window.FazendaRP.SuprimentosData.find(d => d.id === id);
                    if (item) {
                        item.expanded = !item.expanded;
                        // this.saveData(); // State is ephemeral in memory now OR could be saved to user prefs
                        this.renderTree(searchTerm, customContainer, customEditorContainer);
                        // Re-activate
                        const newNode = container.querySelector(`.tree-node[data-id="${id}"]`);
                        if (newNode) newNode.classList.add('active');
                    }
                });
            }
        });
    },

    renderEditor: function (id, customContainer = null) {
        const container = customContainer || document.getElementById('item-details-container');
        if (!container) return;

        const item = window.FazendaRP.SuprimentosData.find(d => d.id === id);
        if (!item) return;

        const isItem = item.tipo === 'ITEM';

        let html = `
            <div style="border-bottom: 1px solid #eee; padding-bottom: 15px; margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
                <h3 style="margin: 0; color: var(--color-primary);">${isItem ? 'Editar Material' : 'Editar Categoria'}</h3>
                <div>
                     <button id="btn-delete" class="btn-sm" style="color:red; background:none; border:none; cursor:pointer;" title="Arquivar/Inativar"><i class="fas fa-archive"></i></button>
                </div>
            </div>
            
            <form id="form-suprimento">
                <input type="hidden" id="editor-item-id" value="${item.id}">
                <div class="form-group">
                    <label style="font-size:0.85rem; color:#6b7280;">Nome</label>
                    <input type="text" id="sup-nome" value="${item.nome}" class="form-control">
                </div>
                <div class="form-group" style="margin-top:10px;">
                   <label style="font-size:0.85rem; color:#6b7280;">Localização (Categoria)</label>
                   <select id="editor-parent-select" class="form-control">
                       <option value="ROOT" ${!item.parentId ? 'selected' : ''}>📂 Raiz (Sem Pai)</option>
                       ${this.generateCategoryOptions(item.parentId, item.id)}
                   </select>
                </div>
        `;

        if (!isItem) {
            html += `
                 <div class="form-group" style="margin-top: 15px;">
                    <label style="display:flex; justify-content: space-between; align-items:center; cursor:pointer; width:100%;">
                         <span>Exigir vínculo com Máquina</span>
                         <input type="checkbox" id="cat-fluxo-maquina" ${item.requiresMachine ? 'checked' : ''}>
                    </label>
                    <small style="color:#666; display:block; margin-left:22px;">Dica: Evite marcar em Categorias Gerais. Prefira marcar nas Subcategorias específicas.</small>
                </div>
            `;
        }


        if (isItem) {
            html += `
            <div class="form-group">
                    <label>Unidades de Medida</label>
                    <div id="editor-units-chips" style="display:flex; flex-wrap:wrap; gap:5px; margin-bottom:5px;"></div>
                    <div style="display:flex; gap:5px;">
                        <select id="editor-unidade-select" class="form-control" style="max-width: 200px;">
                             ${UNIDADE_OPTS.map(u => `<option value="${u.val}">${u.label}</option>`).join('')}
                        </select>
                        <button type="button" id="editor-btn-add-unit" class="btn-add-plus">+</button>
                    </div>
                </div>

            <div style="margin-top: 30px; border-top: 1px solid #f0f0f0; padding-top: 20px;">
                <h4 style="font-size: 0.95rem; margin-bottom: 5px; color: #374151;">Vínculos Contábeis</h4>
                <p style="font-size: 0.8rem; color: #6b7280; margin-bottom: 15px;">Defina quais contas contábeis podem ser usadas ao comprar este item.</p>

                <div id="chips-container" style="margin-bottom: 15px; min-height: 40px;"></div>

                <div style="display: flex; gap: 10px;">
                    <input list="list-plano-contas-sup" id="input-add-conta-sup" placeholder="Buscar conta..." class="form-control">
                        <datalist id="list-plano-contas-sup"></datalist>
                        <button type="button" id="btn-vincular-conta" class="btn-add-plus">+</button>
                </div>
            </div>

            <div style="margin-top: 20px;">
                <label style="font-size:0.85rem; color:#6b7280;">Observações / Princípios Ativos, etc</label>
                <textarea id="sup-principio" class="form-control" rows="3" placeholder="Insira princípios ativos, detalhes técnicos ou observações...">${item.principioAtivo || ''}</textarea>
            </div>
        `;
        }

        html += `
                <div style="margin-top: 30px; text-align: right;">
                    <button type="submit" class="btn btn-success">Salvar Alterações</button>
                </div>
            </form>
        `;

        container.innerHTML = html;

        if (isItem) {
            // Init Units & Accounts
            if (!item.unidades) item.unidades = [];
            this.renderUnitChips(item.unidades, 'editor-units-chips');

            this.renderChips(item.contas, 'chips-container');
            this.populateDatalist('list-plano-contas-sup');

            // Accounts Logic
            const input = document.getElementById('input-add-conta-sup');
            input.addEventListener('input', (e) => { if (e.target.value.includes('⚫')) e.target.value = ''; });
            document.getElementById('btn-vincular-conta').addEventListener('click', () => {
                this.handleLinkAccount(item, input, 'chips-container', true); // Auto-save logic now just updates memory, waiting for submit
            });

            // Units Logic (Editor)
            document.getElementById('editor-btn-add-unit').addEventListener('click', () => {
                const sel = document.getElementById('editor-unidade-select');
                const val = sel.value;
                if (!item.unidades.includes(val)) {
                    item.unidades.push(val);
                    // this.saveData(); // Waity for Save Button
                    this.renderUnitChips(item.unidades, 'editor-units-chips');
                }
            });
        }

        const form = document.getElementById('form-suprimento');
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const nome = document.getElementById('sup-nome').value;

            // Handle Category Move
            const newParentVal = document.getElementById('editor-parent-select').value;
            const newParentId = newParentVal === 'ROOT' ? null : newParentVal;

            let requiresMachine = item.requiresMachine;
            let principioAtivo = null;

            if (isItem) {
                principioAtivo = document.getElementById('sup-principio').value;
            } else {
                requiresMachine = document.getElementById('cat-fluxo-maquina').checked;
            }

            // AUTO-SAVE FIX: Check if there is a pending Account in the input and add it
            const inputConta = document.getElementById('input-add-conta-sup');
            if (isItem && inputConta && inputConta.value.trim()) {
                console.log("Auto-adding pending account:", inputConta.value);
                this.handleLinkAccount(item, inputConta, 'chips-container', true);
            }

            const btn = form.querySelector('button[type="submit"]');
            const originalText = btn.innerText;
            btn.innerText = 'Salvando...';
            btn.disabled = true;

            // Update Supabase
            const { error } = await window.FazendaRP.supabase
                .from('suprimentos_itens')
                .update({
                    nome: nome,
                    parent_id: newParentId,
                    requires_machine: requiresMachine,
                    unidades: item.unidades,
                    contas: item.contas,
                    principio_ativo: principioAtivo
                })
                .eq('id', item.id);

            if (error) {
                alert('Erro ao atualizar: ' + error.message);
                btn.innerText = originalText;
                btn.disabled = false;
                return;
            }

            // Update Local Memory (Optimistic)
            item.nome = nome;
            item.parentId = newParentId;
            item.requiresMachine = requiresMachine;
            item.principioAtivo = principioAtivo || item.principioAtivo;

            // FORCE RE-FETCH ON NEXT RENDER (Truth Source)
            // This ensures that what we see is what is in DB, preventing cache desync issues.
            window.FazendaRP.SuprimentosLoaded = false;

            // this.saveData(); // Not needed
            this.renderTree();

            const newNode = document.querySelector(`.tree-node[data-id="${item.id}"]`);
            if (newNode) newNode.classList.add('active');

            btn.innerText = 'Salvo!';
            btn.style.background = '#059669';
            setTimeout(() => {
                btn.innerText = originalText;
                btn.style.background = ''; // Reset
                btn.disabled = false;
            }, 1500);
        });

        const btnDelete = document.getElementById('btn-delete');
        if (btnDelete) {
            btnDelete.addEventListener('click', async () => {
                if (confirm('Tem certeza? Isso ARQUIVARÁ este item e todos os seus sub-itens/variações. Eles deixarão de aparecer nas listas.')) {
                    const deleteIds = [item.id];
                    const findChildren = (pid) => {
                        const kids = window.FazendaRP.SuprimentosData.filter(x => x.parentId === pid);
                        kids.forEach(k => { deleteIds.push(k.id); findChildren(k.id); });
                    };
                    findChildren(item.id);

                    // DB Soft Delete (Update Status)
                    const { error } = await window.FazendaRP.supabase
                        .from('suprimentos_itens')
                        .update({ status: 'Inativo' })
                        .in('id', deleteIds);

                    if (error) {
                        alert('Erro ao arquivar: ' + error.message);
                        return;
                    }

                    // Memory Update
                    window.FazendaRP.SuprimentosData = window.FazendaRP.SuprimentosData.filter(x => !deleteIds.includes(x.id));
                    // this.saveData(); 
                    this.renderTree();
                    container.innerHTML = `
                        <div style="display: flex; flex-direction: column; height: 100%; justify-content: center; align-items: center; color: #9ca3af;">
                            <i class="fas fa-archive fa-3x" style="margin-bottom: 15px; opacity: 0.3;"></i>
                            <p>Item arquivado com sucesso.</p>
                        </div>
                    `;
                }
            });
        }
    },

    bindGlobalEvents: function () {
        // Modal Add Unit (Static HTML)
        const btnAddUnitModal = document.getElementById('btn-add-unit-modal');
        if (btnAddUnitModal) {
            btnAddUnitModal.onclick = (e) => {
                e.preventDefault();
                const sel = document.getElementById('mat-unidade-select');
                if (!sel) return;
                const val = sel.value;
                if (!val) return;

                if (!this.tempUnidades.includes(val)) {
                    this.tempUnidades.push(val);
                    this.renderUnitChips(this.tempUnidades, 'modal-units-chips', true);
                } else {
                    // Optional: Visual Feedack for duplicates
                    const btn = e.target;
                    const originalBg = btn.style.background;
                    btn.style.background = '#fecaca'; // Red tint
                    setTimeout(() => { btn.style.background = originalBg; }, 300);
                }
            };
        }

        // Config Linker in Modal (Static HTML)
        const btnAddContaModal = document.getElementById('btn-add-conta-modal');
        const inputContaModal = document.getElementById('input-conta-modal');
        if (btnAddContaModal) {
            btnAddContaModal.onclick = () => { this.handleLinkAccount(null, inputContaModal, 'modal-chips-container', false); };
            inputContaModal.oninput = (e) => { if (e.target.value.includes('⚫')) e.target.value = ''; };
        }

        // Note: Modal Open buttons are Dynamic in Catalog, so they stay in setupGeneralEvents.
        // Note: Form Submit logic can also live here if the Form is static.

        // + Material Submit (Static HTML)
        const formNovoMaterial = document.getElementById('form-novo-material');
        if (formNovoMaterial) {
            // Use onclick or onsubmit replacement to prevent stacking
            formNovoMaterial.onsubmit = (e) => {
                e.preventDefault();

                let parentId = null;
                const chkVar = document.getElementById('mat-is-variation');

                if (chkVar && chkVar.checked) {
                    const val = document.getElementById('mat-parent-search').value.trim();
                    if (!val) { alert("Informe o Item Pai Genérico."); return; }

                    // Resolve ID from Name (Exact Match)
                    const pItem = window.FazendaRP.SuprimentosData.find(d => d.tipo === 'ITEM' && d.nome.toLowerCase() === val.toLowerCase());
                    if (!pItem) { alert("Item Pai não encontrado. Selecione um item válido da lista."); return; }

                    parentId = pItem.id;
                } else {
                    parentId = document.getElementById('mat-parent-select').value;
                    if (!parentId) { alert("Selecione uma categoria pai."); return; }
                }

                // Security Check Override
                if (parentId) {
                    const p = window.FazendaRP.SuprimentosData.find(x => x.id === parentId);
                    // Allow Item parent ONLY if checkbox is checked
                    if (p && p.tipo === 'ITEM' && (!chkVar || !chkVar.checked)) {
                        alert("Erro de segurança: Não é possível criar dentro de um Material (use a opção 'Variação').");
                        return;
                    }
                }

                const nome = document.getElementById('mat-nome-modal').value.trim();
                // Allow empty units? Ideally no.
                if (this.tempUnidades.length === 0) { alert("Adicione pelo menos uma unidade."); return; }

                const exists = window.FazendaRP.SuprimentosData.some(d => d.tipo === 'ITEM' && d.parentId === parentId && d.nome.toLowerCase() === nome.toLowerCase());

                if (exists) { alert("Já existe um material com este nome neste local."); return; }

                this.executeAddItem(parentId, 'ITEM', {
                    nome: nome,
                    unidades: this.tempUnidades,
                    contas: this.tempContas
                });
                document.getElementById('modal-novo-material').style.display = 'none';
            };
        }
    },

    // --- LOGIC HELPERS ---

    handleLinkAccount: function (dataTarget, inputEl, containerId, autoSave) {
        const val = inputEl.value;
        if (!val) return;
        if (val.includes('⚫')) { alert("Selecione uma Conta Analítica."); return; }

        const cleanVal = val.replace(/[⚫⚪]\s*/g, '');
        let targetArr = autoSave ? dataTarget.contas : this.tempContas;

        if (!targetArr) targetArr = [];

        if (!targetArr.includes(cleanVal)) {
            targetArr.push(cleanVal);
            if (autoSave) {
                dataTarget.contas = targetArr;
                // this.saveData(); // Wait for Update Button
            } else {
                this.tempContas = targetArr;
            }
            this.renderChips(targetArr, containerId, !autoSave);
        }
        inputEl.value = '';
    },

    generateCategoryOptions: function (selectedId = null, excludeId = null) {
        const data = window.FazendaRP.SuprimentosData;
        let html = '';
        const buildOptions = (parentId, depth) => {
            const children = data.filter(d => d.parentId === parentId && d.tipo === 'CATEGORIA');
            children.sort((a, b) => a.nome.localeCompare(b.nome));
            children.forEach(cat => {
                // Circular dependency check: Don't show the item itself or its children as move options
                if (excludeId && cat.id === excludeId) return;

                const indent = '&nbsp;'.repeat(depth * 4);
                const isSelected = cat.id === selectedId ? 'selected' : '';
                const symbol = depth > 0 ? '↳ ' : '📂 ';
                html += `<option value="${cat.id}" ${isSelected}>${indent}${symbol}${cat.nome}</option>`;
                buildOptions(cat.id, depth + 1);
            });
        };
        buildOptions(null, 0);
        return html;
    },

    getActiveParent: function () {
        const container = document.getElementById('tree-container');
        const active = container.querySelector('.tree-node.active');
        if (!active) return null;

        const id = active.dataset.id;
        const item = window.FazendaRP.SuprimentosData.find(d => d.id === id);
        if (!item) return null;

        if (item.tipo === 'CATEGORIA') return item.id;
        return item.parentId;
    },

    setupGeneralEvents: function () {
        // + Categoria Modal Open
        document.getElementById('btn-add-categ-header').addEventListener('click', () => {
            const activeParentId = this.getActiveParent();
            const select = document.getElementById('cat-parent-select');

            const opts = this.generateCategoryOptions(activeParentId);
            select.innerHTML = `<option value="ROOT">📂 Nova Categoria Raiz</option>` + opts;

            document.getElementById('form-nova-categoria').reset();
            if (!activeParentId) select.value = "ROOT";
            document.getElementById('modal-nova-categoria').style.display = 'flex';
        });

        // + Categoria Submit
        document.getElementById('form-nova-categoria').addEventListener('submit', (e) => {
            e.preventDefault();
            const nome = document.getElementById('cat-nome-modal').value.trim();
            const parentVal = document.getElementById('cat-parent-select').value;
            const parentId = parentVal === 'ROOT' ? null : parentVal;

            // Double Check Security
            if (parentId) {
                const p = window.FazendaRP.SuprimentosData.find(x => x.id === parentId);
                if (p && p.tipo === 'ITEM') { alert("Erro de segurança: Não é possível criar dentro de um Material."); return; }
            }

            const exists = window.FazendaRP.SuprimentosData.some(d => d.tipo === 'CATEGORIA' && d.parentId === parentId && d.nome.toLowerCase() === nome.toLowerCase());
            if (exists) { alert("Nome duplicado nesta pasta."); return; }

            const requiresMachine = document.getElementById('cat-fluxo-maquina-modal').checked;
            this.executeAddItem(parentId, 'CATEGORIA', { nome: nome, requiresMachine: requiresMachine });
            document.getElementById('modal-nova-categoria').style.display = 'none';
        });

        // + Material Modal Open
        // + Material Modal Open
        document.getElementById('btn-add-item-header').addEventListener('click', () => {
            const activeParentId = this.getActiveParent();
            const select = document.getElementById('mat-parent-select');

            const opts = this.generateCategoryOptions(activeParentId);
            select.innerHTML = `<option value="" disabled ${!activeParentId ? 'selected' : ''}>Selecione uma categoria...</option>` + opts;

            this.tempContas = [];
            this.tempUnidades = []; // Default empty

            document.getElementById('form-novo-material').reset();

            // RESET VARIATION UI
            const chkVar = document.getElementById('mat-is-variation');
            if (chkVar) {
                chkVar.checked = false;
                document.getElementById('div-mat-category').style.display = 'block';
                document.getElementById('div-mat-parent-item').style.display = 'none';
                document.getElementById('mat-parent-search').value = '';
                // 'mat-selected-parent-id' removed
            }

            this.renderChips([], 'modal-chips-container', true);
            this.renderUnitChips(this.tempUnidades, 'modal-units-chips', true);
            this.populateDatalist('list-plano-contas-modal');

            document.getElementById('modal-novo-material').style.display = 'flex';
        });

        // VARIATION LOGIC LISTENERS
        const chkVar = document.getElementById('mat-is-variation');
        const divCat = document.getElementById('div-mat-category');
        const divPar = document.getElementById('div-mat-parent-item');
        const inpSearch = document.getElementById('mat-parent-search');

        if (chkVar && !chkVar.dataset.listening) {
            chkVar.dataset.listening = "true";
            chkVar.addEventListener('change', () => {
                if (chkVar.checked) {
                    divCat.style.display = 'none';
                    divPar.style.display = 'block';
                    inpSearch.focus();

                    // Populate Parent Item Datalist from SuprimentosData
                    const dl = document.getElementById('list-parent-items');
                    if (dl) {
                        dl.innerHTML = window.FazendaRP.SuprimentosData
                            .filter(d => d.tipo === 'ITEM')
                            .map(d => `<option value="${d.nome}">`) // Using Name for autocomplete
                            .join('');
                    }
                } else {
                    divCat.style.display = 'block';
                    divPar.style.display = 'none';
                    inpSearch.value = '';
                }
            });
            // No 'input' listener needed for native datalist
        }

        // Modal Add Unit, Submit & Config Linker removed (Moved to bindGlobalEvents)
    },

    executeAddItem: async function (parentId, type, dataPayload) {
        // Prepare DB Payload
        const dbPayload = {
            nome: dataPayload.nome,
            tipo: type,
            parent_id: parentId,
            unidades: dataPayload.unidades || [],
            contas: dataPayload.contas || [],
            requires_machine: dataPayload.requiresMachine || false
        };

        const { data, error } = await window.FazendaRP.supabase
            .from('suprimentos_itens')
            .insert(dbPayload)
            .select()
            .single();

        if (error) {
            console.error(error);
            alert('Erro ao salvar no sistema: ' + error.message);
            return;
        }

        // Update Local Memory
        const newItem = {
            id: data.id,
            nome: data.nome,
            tipo: data.tipo,
            parentId: data.parent_id,
            expanded: true,
            contas: data.contas,
            unidades: data.unidades,
            requiresMachine: data.requires_machine
        };

        window.FazendaRP.SuprimentosData.push(newItem);
        if (parentId) {
            const parent = window.FazendaRP.SuprimentosData.find(d => d.id === parentId);
            if (parent) parent.expanded = true;
        }

        // this.saveData(); // Not needed
        this.renderTree();
        this.renderEditor(newItem.id);
        setTimeout(() => {
            const node = document.querySelector(`.tree-node[data-id="${newItem.id}"]`);
            if (node) node.classList.add('active');
        }, 50);
    },

    renderChips: function (contas, containerId, isTemp = false) {
        const container = document.getElementById(containerId);
        if (!container) return;
        if (!contas || contas.length === 0) {
            container.innerHTML = '<span style="color:#ddd; font-style:italic; font-size:0.8rem;">Nenhum.</span>';
            return;
        }
        container.innerHTML = contas.map((chk) => `
            <div class="chip">
                ${chk} 
                <i class="fas fa-times" onclick="window.FazendaRP.Pages.suprimentos.removeSingleChip('${chk}', '${containerId}', ${isTemp})"></i>
            </div>
        `).join('');
    },

    renderUnitChips: function (units, containerId, isTemp = false) {
        const container = document.getElementById(containerId);
        if (!container) return;
        container.innerHTML = units.map((u) => `
            <div class="chip chip-unit">
                ${u} 
                <i class="fas fa-times" onclick="window.FazendaRP.Pages.suprimentos.removeSingleUnit('${u}', '${containerId}', ${isTemp})"></i>
            </div>
        `).join('');
    },

    removeSingleChip: function (conta, containerId, isTemp) {
        if (isTemp) {
            this.tempContas = this.tempContas.filter(c => c !== conta);
            this.renderChips(this.tempContas, containerId, true);
        } else {
            const itemId = document.getElementById('editor-item-id').value;
            this.removeConta(conta, itemId);
        }
    },

    removeSingleUnit: function (unit, containerId, isTemp) {
        if (isTemp) {
            this.tempUnidades = this.tempUnidades.filter(u => u !== unit);
            this.renderUnitChips(this.tempUnidades, containerId, true);
        } else {
            const itemId = document.getElementById('editor-item-id').value;
            const item = window.FazendaRP.SuprimentosData.find(d => d.id === itemId);
            if (item) {
                item.unidades = item.unidades.filter(u => u !== unit);
                // this.saveData(); // Removed: Persistence is on Save Button
                this.renderUnitChips(item.unidades, containerId);
            }
        }
    },

    removeConta: function (contaName, itemId) {
        const item = window.FazendaRP.SuprimentosData.find(d => d.id === itemId);
        if (item) {
            item.contas = item.contas.filter(c => c !== contaName);
            // this.saveData(); // Removed: Persistence is on Save Button
            this.renderChips(item.contas, 'chips-container');
        }
    },

    populateDatalist: function (listId) {
        const datalist = document.getElementById(listId);
        if (!datalist) return;
        if (window.FazendaRP.Pages.financeiro && window.FazendaRP.Pages.financeiro.initPlanoContasData) {
            window.FazendaRP.Pages.financeiro.initPlanoContasData();
            const accounts = window.FazendaRP.Pages.financeiro.planoContasData || [];
            datalist.innerHTML = accounts.map(c => {
                const isAnalytical = c.tipo === 'CONTA' || c.tipo === 'ANALITICA';
                const prefix = isAnalytical ? '⚪ ' : '⚫ ';
                return `<option value="${prefix}${c.codigo} - ${c.nome}">`;
            }).join('');
        }
    }
};
